import { render, staticRenderFns } from "./NotVipHeader.vue?vue&type=template&id=a01cb74a&scoped=true&"
import script from "./NotVipHeader.vue?vue&type=script&lang=ts&"
export * from "./NotVipHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NotVipHeader.vue?vue&type=style&index=0&id=a01cb74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01cb74a",
  null
  
)

export default component.exports